import { pluginApi, setApiMode } from 'services/api';
import { transform } from './transformers/spin-extract-transformer';

export async function getSpinsExtract() {
  setApiMode('write');
  const response = await pluginApi.post('/luckynumbers/extract');

  return transform(response.data);
}
